import { render, staticRenderFns } from "./SlTaxDocumentDetail.vue?vue&type=template&id=17583a3c&lang=pug&"
import script from "./SlTaxDocumentDetail.vue?vue&type=script&lang=js&"
export * from "./SlTaxDocumentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SlTaxDocumentDetail.vue"
export default component.exports